import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, of, throwError} from 'rxjs';
import {ChatRecordsOnRequestModel} from '../views/models/chat-records-on-request.model';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
import {catchError, delay, first, retryWhen, switchMap} from 'rxjs/operators';
import {ChatHeaderModel} from '../views/models/chat-header.model';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatService implements OnDestroy {
  chatRecordsOnRequest = new BehaviorSubject<ChatRecordsOnRequestModel[]>([]);
  ws: WebSocketSubject<ChatRecordsOnRequestModel>;
  RETRY_SECONDS = 10;
  chatHeaders = new BehaviorSubject<ChatHeaderModel[]>([]);


  constructor(private httpClient: HttpClient) {
  }

  sendMessage(val: ChatRecordsOnRequestModel) {
    console.log(val.id + ', ' + val.message);
    this.ws.next(val);
  }

  GetRequestChats(id: number, fn1: void) {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/request/' + id + '/chatrecords').subscribe(
      (datas: ChatRecordsOnRequestModel[]) => {
        this.chatRecordsOnRequest.next(datas);
      }, (err) => {
        console.log(err);
      }
    );
  }

  addchatRecordsOnRequest(dataObj) {
    const currentValue = this.chatRecordsOnRequest.value;
    const updatedValue = [...currentValue, dataObj];
    this.chatRecordsOnRequest.next(updatedValue);
  }

  postChatMessage(data: ChatRecordsOnRequestModel): Observable<ChatRecordsOnRequestModel> {
    return this.httpClient.post<ChatRecordsOnRequestModel>(environment.baseURL + '/v2/api' + '/request/chatrecords', data)
      .pipe(first());
  }

  connectWs(id: number): Observable<ChatRecordsOnRequestModel> {
    // no more than one connection simultaneously
    if (!(this.ws == null)) {
      console.log('no more than one connection simultaneously');
      this.ws.complete();
    }
    let wsUri = environment.baseURL.replace('https://', 'wss://').replace('http://', 'ws://') + '/v2';
    wsUri += '/request/' + id + '/ws';
    return of(wsUri).pipe(
      switchMap(wsUrl => {
        console.log(wsUrl);
        if (this.ws) {
          return this.ws;
        } else {
          this.ws = webSocket(wsUrl);
          return this.ws;
        }
      }),
      retryWhen((errors) => errors.pipe(delay(this.RETRY_SECONDS)))
    );
  }

  disconnectWs() {
    console.log('disconnectWs');
    if (this.ws) {
      this.ws.complete();
      this.ws = null;
      console.log('IndisconnectWs');
    }
  }

  ngOnDestroy() {
    console.log('service destroy');
    this.disconnectWs();
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  GetChatHeaders() {
    this.httpClient.get(environment.baseURL + '/v2/api' + '/chatheaders').subscribe(
      (datas: ChatHeaderModel[]) => {
        // tslint:disable-next-line:only-arrow-functions
        if (datas) {
          datas.forEach(function(val) {
            if (new Date(val.last_time).getFullYear() < 2000) {
              val.last_time = new Date();
            }
            if (val.send_time > 6000) {
              val.send_time = null;
            }
          });
          datas = datas.sort((val, xval) => {
            if (val.last_time < xval.last_time) {
              return 1;
            }
            if (val.last_time > xval.last_time) {
              return -1;
            }
            return 0;
          });
          this.chatHeaders.next(datas);
        }


      }, (err) => {
        console.log(err);
      }
    );
  }

}

